import { render, staticRenderFns } from "./Diners.vue?vue&type=template&id=19ce556e"
import script from "./Diners.vue?vue&type=script&lang=js"
export * from "./Diners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports